import { render, staticRenderFns } from "./ServerManager.vue?vue&type=template&id=65f27956&scoped=true&"
import script from "./ServerManager.vue?vue&type=script&lang=js&"
export * from "./ServerManager.vue?vue&type=script&lang=js&"
import style0 from "./ServerManager.vue?vue&type=style&index=0&id=65f27956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f27956",
  null
  
)

export default component.exports